import { AttemptRefresh } from "./RouterErrorBoundary";

export function makeLazyRoute<T extends () => Promise<React.ComponentType>>(
  importer: T
) {
  return async function lazy() {
    try {
      const LazyComponent = await importer();

      function Component() {
        return <LazyComponent />;
      }

      return { Component };
    } catch (e) {
      console.error(e);
      return {
        Component: AttemptRefresh,
      };
    }
  };
}
